/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CreateAdvancePaymentMutationVariables = Types.Exact<{
  charterId: Types.Scalars['Long']['input'];
  amount: Types.Scalars['BigDecimal']['input'];
  vatCodeId: Types.Scalars['Long']['input'];
}>;


export type CreateAdvancePaymentMutation = {
  __typename?: 'Mutation',
  createAdvancePayment?: {
    __typename?: 'PurchaseDeclaration',
    id: number,
    closedOn?: number | null,
    financiallyReadiedOn?: number | null,
    totalPriceExcVAT?: number | null,
    window?: {
      __typename?: 'TimeWindow',
      from?: number | null,
      to?: number | null
    } | null,
    lastStatusChange?: {
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    } | null,
    statusChanges: Array<{
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    }>,
    invoiceGroupType?: {
      __typename?: 'InvoiceGroupType',
      id: number,
      name: string
    } | null,
    charter?: {
      __typename?: 'PurchaseCharter',
      blDate?: number | null,
      id: number,
      charterNumber: string,
      type: Types.CharterType,
      customerReference?: string | null,
      subtype: Types.CharterSubtype,
      voyages?: Array<{
        __typename?: 'Voyage',
        ship: {
          __typename?: 'Ship',
          id: number,
          name: string
        },
        cargoCharters?: Array<{
          __typename?: 'SalesCharter',
          id: number,
          charterNumber: string,
          type: Types.CharterType,
          subtype: Types.CharterSubtype,
          customerReference?: string | null,
          dossierNumber?: string | null
        } | null> | null
      }> | null,
      contract?: {
        __typename?: 'Contract',
        currency?: {
          __typename?: 'Currency',
          symbol?: string | null,
          isoCode?: string | null
        } | null
      } | null
    } | {
      __typename?: 'SalesCharter',
      blDate?: number | null,
      dossierNumber?: string | null,
      customerReference?: string | null,
      id: number,
      charterNumber: string,
      type: Types.CharterType,
      subtype: Types.CharterSubtype,
      status: {
        __typename?: 'SalesCharterStatusType',
        name: Types.SalesCharterStatus,
        color: string,
        languageKeyPrefix: string
      },
      purchaseCharter?: {
        __typename?: 'PurchaseCharter',
        charterNumber: string,
        type: Types.CharterType,
        subtype: Types.CharterSubtype,
        voyages?: Array<{
          __typename?: 'Voyage',
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string
          }
        }> | null
      } | null,
      contract?: {
        __typename?: 'Contract',
        currency?: {
          __typename?: 'Currency',
          symbol?: string | null,
          isoCode?: string | null
        } | null
      } | null
    } | null,
    invoiceLines: Array<{
      __typename?: 'InvoiceLine',
      id: number,
      approved?: boolean | null,
      invoice?: {
        __typename?: 'Invoice',
        id: number,
        invoiceNumber?: string | null
      } | null,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null
    }>
  } | {
    __typename?: 'SalesDeclaration',
    id: number,
    closedOn?: number | null,
    financiallyReadiedOn?: number | null,
    totalPriceExcVAT?: number | null,
    window?: {
      __typename?: 'TimeWindow',
      from?: number | null,
      to?: number | null
    } | null,
    lastStatusChange?: {
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    } | null,
    statusChanges: Array<{
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    }>,
    invoiceGroupType?: {
      __typename?: 'InvoiceGroupType',
      id: number,
      name: string
    } | null,
    charter?: {
      __typename?: 'PurchaseCharter',
      blDate?: number | null,
      id: number,
      charterNumber: string,
      type: Types.CharterType,
      customerReference?: string | null,
      subtype: Types.CharterSubtype,
      voyages?: Array<{
        __typename?: 'Voyage',
        ship: {
          __typename?: 'Ship',
          id: number,
          name: string
        },
        cargoCharters?: Array<{
          __typename?: 'SalesCharter',
          id: number,
          charterNumber: string,
          type: Types.CharterType,
          subtype: Types.CharterSubtype,
          customerReference?: string | null,
          dossierNumber?: string | null
        } | null> | null
      }> | null,
      contract?: {
        __typename?: 'Contract',
        currency?: {
          __typename?: 'Currency',
          symbol?: string | null,
          isoCode?: string | null
        } | null
      } | null
    } | {
      __typename?: 'SalesCharter',
      blDate?: number | null,
      dossierNumber?: string | null,
      customerReference?: string | null,
      id: number,
      charterNumber: string,
      type: Types.CharterType,
      subtype: Types.CharterSubtype,
      status: {
        __typename?: 'SalesCharterStatusType',
        name: Types.SalesCharterStatus,
        color: string,
        languageKeyPrefix: string
      },
      purchaseCharter?: {
        __typename?: 'PurchaseCharter',
        charterNumber: string,
        type: Types.CharterType,
        subtype: Types.CharterSubtype,
        voyages?: Array<{
          __typename?: 'Voyage',
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string
          }
        }> | null
      } | null,
      contract?: {
        __typename?: 'Contract',
        currency?: {
          __typename?: 'Currency',
          symbol?: string | null,
          isoCode?: string | null
        } | null
      } | null
    } | null,
    invoiceLines: Array<{
      __typename?: 'InvoiceLine',
      id: number,
      approved?: boolean | null,
      invoice?: {
        __typename?: 'Invoice',
        id: number,
        invoiceNumber?: string | null
      } | null,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null
    }>
  } | null
};

export type DeleteInvoiceMutationVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type DeleteInvoiceMutation = {
  __typename?: 'Mutation',
  deleteInvoice?: boolean | null
};


export const CreateAdvancePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAdvancePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"charterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigDecimal"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vatCodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAdvancePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"charterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"charterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"vatCodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vatCodeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"declarationRowFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"declarationRowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Declaration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"closedOn"}},{"kind":"Field","name":{"kind":"Name","value":"financiallyReadiedOn"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceExcVAT"}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGroupType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"customerReference"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blDate"}},{"kind":"Field","name":{"kind":"Name","value":"dossierNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerReference"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseCharter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"voyages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blDate"}},{"kind":"Field","name":{"kind":"Name","value":"voyages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargoCharters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"customerReference"}},{"kind":"Field","name":{"kind":"Name","value":"dossierNumber"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"isoCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}}]} as unknown as DocumentNode<CreateAdvancePaymentMutation, CreateAdvancePaymentMutationVariables>;
export const DeleteInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;